module.exports = __webpack_public_path__ + "static/media/icon-input.eb643463.svg";